import { PrimaryButton } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";

import { AddressInputField } from "./AddressInputField";
import { AddressSummaryField } from "./AddressSummaryField";
import { MissingCountriesModal } from "./MissingCountriesModal";
import { getMissingCountries } from "./utils";
import { getValidationRule } from "../../validationRules";
import { Rules } from "../../validationRules/types";
import { FieldType } from "../types";

export function AddressField(
  field: components["schemas"]["AddressesCheckField"]
): FieldType<components["schemas"]["AddressesCheckField"]> {
  return {
    field,
    inputElement: <AddressInputField key={field.name} field={field} />,
    summaryElement: () => (
      <AddressSummaryField key={field.name} field={field} />
    ),
    saveButtonOverride: ({ values, submitForm }) => {
      const rule = getValidationRule<
        components["schemas"]["RequestedInternationalAddressesRule"]
      >(field, Rules.REQUESTED_INTL_ADDRESSES);

      if (!rule) {
        return undefined;
      }

      const missingCountries = getMissingCountries(
        values[field.name],
        rule.rule?.value ?? []
      );

      if (missingCountries.length > 0)
        return (
          <MissingCountriesModal
            key={field.name + "_presave_modal"}
            missingCountries={missingCountries}
            onContinue={submitForm}
            trigger={
              <PrimaryButton size="medium">{t("Next step")}</PrimaryButton>
            }
          />
        );

      return undefined;
    },
    initialValue: field.value,
  };
}
